import React, { useState, useEffect } from "react";

import {
  Card,
  Dropdown,
  message,
  Menu,
  Avatar,
  Modal,
  Form,
  Input,
  Spin,
  Space,
  Cascader,
  DatePicker,
  Button,
  Tag,
  Alert,
  Drawer,
  Pagination,
} from "antd";

import {
  SnippetsFilled,
  DesktopOutlined,
  ExportOutlined,
  CaretDownOutlined,
  PlusCircleFilled,
  RightOutlined,
  ForwardFilled,
} from "@ant-design/icons";

import { Http } from "../Http";
import queryString from "query-string";
import Cookies from "js-cookie";

import { areaTree, cateTree } from "../Tree.js";

import logo from "../images/logo.png";
import pay from "../images/pay.jpg";
import s1 from "../images/template_s1.jpg";
import s2 from "../images/template_s2.jpg";
import s3 from "../images/template_s3.jpg";
import s4 from "../images/template_s4.jpg";
import s5 from "../images/template_s5.jpg";
import s6 from "../images/template_s6.jpg";
import s7 from "../images/template_s7.jpg";
import s8 from "../images/template_s8.jpg";
import s9 from "../images/template_s9.jpg";
import s10 from "../images/template_s10.jpg";
import s11 from "../images/template_s11.jpg";

import styles from "./Welcome.module.less";

const { confirm } = Modal;

function Welcome({ navigate, user }) {
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [mold, setMold] = useState(false);
  const [drawer, setDrawer] = useState(false);
  const [brandList, setBrandList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 11,
    total: 0,
  });

  const [form] = Form.useForm();

  const theme = [
    { name: "1号模板", pic: s1 },
    { name: "2号模板", pic: s2 },
    { name: "3号模板", pic: s3 },
    { name: "4号模板", pic: s4 },
    { name: "5号模板", pic: s5 },
    { name: "6号模板", pic: s6 },
    { name: "7号模板", pic: s7 },
    { name: "8号模板", pic: s8 },
    { name: "9号模板", pic: s9 },
    { name: "10号模板", pic: s10 },
    { name: "11号模板", pic: s11 },
  ];

  const onLogout = async () => {
    try {
      let para = queryString.stringify({});
      let parsed = await Http.get(`logout`, {
        searchParams: para,
      }).json();
      if (parsed.state === "ok") {
        window.location = "https://sso.chinaqyz.com/";
      } else {
        await message.warn("退出失败");
      }
    } catch (error) {
      await message.error("接口调用错误");
    } finally {
    }
  };

  const onReturn = () => {
    window.location = "https://sso.chinaqyz.com/";
  };

  const onOpen = (value) => {
    navigate(`/website/overview`);
    Cookies.set("bid", value.id);
  };

  const getBrandList = async (params) => {
    let para = queryString.stringify(params);
    let parsed = await Http.get(`brand`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setBrandList(parsed.result.list);
      setPagination({
        current: parsed.result.pageNumber,
        pageSize: parsed.result.pageSize,
        total: parsed.result.totalRow,
      });
    }
  };

  const onLoading = async (params) => {
    setLoading(true);
    try {
      await getBrandList({
        pageNumber: params.pagination.current,
        pageSize: params.pagination.pageSize,
      });
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    values.expiredTime = values.expiredTime.format("YYYY-MM-DD HH:mm:ss");
    values.status = 1;
    values.theme = `s${values.theme.replace(/[^0-9]/gi, "")}`;
    console.log(values);
    let para = queryString.stringify(values);
    try {
      let parsed = await Http.post(`brand/save`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        setVisible(false);
        onLoading({ pagination });
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const userDrop = (
    <Menu>
      <Menu.Item>
        <Space onClick={onReturn}>
          <DesktopOutlined />
          <span>返回中台</span>
        </Space>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <Space onClick={onLogout}>
          <ExportOutlined />
          <span>退出登录</span>
        </Space>
      </Menu.Item>
    </Menu>
  );

  const payView = () => {
    confirm({
      title: null,
      icon: null,
      centered: true,
      content: (
        <div>
          <img src={pay} />
        </div>
      ),
      className: "confirm",
      onOk() {
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const modalView = (value) => {
    if (value) {
      return (
        <div className={styles.buy}>
          <h2>
            您的会员级别：<span>体验会员</span>
          </h2>
          <h2>您可以升级为正式会员，特享百度资源，获取更多曝光与商机。</h2>
          <div className={styles.box}>
            <div className={styles.price}>
              <span>原价：1280 元/月</span>
              <span>
                现价：<i>98</i> 元/月
              </span>
            </div>
            <h2>包含：优化版金钻会员 + 核心词优化 + 联盟平台 + 产品代运营</h2>
            <h2>
              开通状态：<a onClick={() => payView()}>点此开通</a>
            </h2>
          </div>
        </div>
      );
    } else {
      return (
        <Form labelCol={{ span: 5 }} form={form} onFinish={onFinish}>
          <Form.Item
            label="店铺名称"
            name="name"
            rules={[
              {
                required: true,
                message: "请输入店铺名称, 如步步高点读机，没有则填写公司名",
              },
            ]}
          >
            <Input placeholder="请输入店铺名称, 如步步高点读机，没有则填写公司名" />
          </Form.Item>
          <Form.Item
            label="店铺英文名"
            name="alias"
            rules={[
              {
                required: true,
                pattern: /^[a-z][a-z0-9]{4,14}$/,
                message: "必须以英文开头5-15位字符, 只允许小写字母和数字",
              },
              {
                validator: (rule, value) => {
                  if (value) {
                    let para = { alias: value };
                    if (form.getFieldValue("id")) {
                      para.id = form.getFieldValue("id");
                    }
                    return Http.get("brand/unique", {
                      searchParams: para,
                    })
                      .json()
                      .then((parsed) => {
                        if (parsed.state === "ok") {
                          throw "此英文名称已存在, 请更改!";
                        } else {
                          let keep = [
                            "admin",
                            "guest",
                            "baidu",
                            "sogou",
                            "weibo",
                            "weixin",
                            "china",
                          ];
                          if (keep.includes(value.trim())) {
                            throw `${value}是保留名称，请重新输入一个名称`;
                          }
                        }
                      });
                  } else {
                    return Promise.resolve();
                  }
                },
              },
            ]}
          >
            <Input
              disabled={form.getFieldValue("alias") ? true : false}
              placeholder="请输入店铺英文名, 只能填写小写字母或数字, 如bbgddj"
            />
          </Form.Item>
          <Form.Item
            label="所属行业"
            name="cate"
            rules={[{ required: true, message: "请选择所属行业" }]}
          >
            <Cascader options={cateTree} placeholder="请选择所属行业" />
          </Form.Item>
          <Form.Item
            label="所在地区"
            name="area"
            rules={[{ required: true, message: "请选择所在地区" }]}
          >
            <Cascader options={areaTree} placeholder="请选择所在地区" />
          </Form.Item>
          <Form.Item
            label="过期时间"
            name="expiredTime"
            rules={[{ required: true, message: "请选择过期时间" }]}
          >
            <DatePicker
              placeholder="请选择过期时间"
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            label="店铺模板"
            name="theme"
            required={true}
            style={{ marginBottom: 0 }}
          >
            <Input
              onClick={() => {
                setDrawer(true);
              }}
              placeholder="请选择模板"
            />
          </Form.Item>
        </Form>
      );
    }
  };

  useEffect(() => {
    if (user) {
      onLoading({ pagination });
    }
  }, [user]);

  return (
    <div className={styles.Welcome}>
      <div className={styles.header}>
        <div className={styles.w1200}>
          <div className={styles.logo}>
            <img src={logo} alt="" />
          </div>
          <Dropdown overlay={userDrop} placement="bottomRight" arrow>
            <div className={styles.user}>
              <Avatar
                size={32}
                style={{ backgroundColor: "#fde3cf" }}
                src={
                  user?.avatar
                    ? user.avatar
                    : "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                }
              />
              <span>{user?.username ? user.username : "-----"}</span>
              <CaretDownOutlined />
            </div>
          </Dropdown>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.w1200}>
          <Alert
            message="使用指南"
            description={
              <Space direction="vertical" size={2}>
                <span>1. 点击新增店铺，填加您的店铺信息！</span>
                <span>
                  2.
                  添加成功后，此页面会出现您添加的店铺列表，点击右上角“进入”按钮，进入店铺界面进行相关操作！
                </span>
              </Space>
            }
            type="warning"
            showIcon
          />
          <div className={styles.brand}>
            {loading ? (
              <div className={styles.loading}>
                <Spin />
              </div>
            ) : (
              <div className={styles.list}>
                <Card bordered={false}>
                  <div
                    className={styles.add}
                    onClick={() => {
                      form.resetFields();
                      setMold(false);
                      setVisible(true);
                    }}
                  >
                    <PlusCircleFilled />
                    <i>新增店铺</i>
                  </div>
                </Card>
                {brandList.map((value) => (
                  <Card
                    title={
                      <div className={styles.title}>
                        <SnippetsFilled />
                        {value.name}
                      </div>
                    }
                    bordered={false}
                    extra={
                      value.status >= 1 ? (
                        <Tag color="#2db7f5" onClick={() => onOpen(value)}>
                          进入
                        </Tag>
                      ) : null
                    }
                    key={value.id}
                  >
                    <div className={styles.box}>
                      <p>店铺英文名：{value.alias}</p>
                      <p>所属行业：{value.child.name}</p>
                      <p>
                        地区：{value.province.name}-{value.city.name}-
                        {value.region.name}
                      </p>
                      <p>有效期至：{value.expiredTime}</p>
                      {value.status === 0 ? <Tag color="red">禁止</Tag> : null}
                      {value.status === 1 ? (
                        <Tag color="orange">待完善</Tag>
                      ) : null}
                      {value.status >= 2 ? <Tag color="green">正常</Tag> : null}
                    </div>
                  </Card>
                ))}
              </div>
            )}
          </div>
          {loading ? null : brandList.length > 0 ? (
            <div className={styles.pagination}>
              <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                showTotal={() => `总共 ${pagination.total} 条记录`}
                onChange={(e) => {
                  setPagination({
                    ...pagination,
                    current: e,
                  });
                  onLoading({
                    pagination: {
                      ...pagination,
                      current: e,
                    },
                  });
                }}
              />
            </div>
          ) : null}
          {/* <div className={styles.privilege}>
              <div className={styles.title}>专享特权</div>
              <div className={styles.box}>
                <div className={styles.col}>
                  <h2>
                    <span>站内优先排名</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>产品优先推荐</p>
                    <p>公司搜索结果页</p>
                    <p>产品搜索结果页</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>行业黄金广告</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>海量曝光</p>
                    <p>快人一步</p>
                    <p>会员专享</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>商机信息推广</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>百度、360、搜狗、神马</p>
                    <p>供应信息主动提交收录</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>商铺统计</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.stat}>
                    <div className={styles.show}>
                      <p>
                        <span>0</span>
                        <span>商铺浏览量</span>
                      </p>
                      <p>
                        <span>0</span>
                        <span>商铺访客数</span>
                      </p>
                    </div>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>关键词挖掘</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>会员专享</p>
                    <p>轻松获取流量长尾词</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>站内标王</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>会员专享</p>
                    <p>关键词排名前三</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>优质原创快推</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>会员专享</p>
                    <p>针对原创信息提交单独的流量入口</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>横幅设计</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>会员专享</p>
                    <p>1个横幅设计(价值500元/张）</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>店铺模板</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.promotion}>
                    <div className={styles.show}>
                      <p>
                        <span>有广告</span>
                        <span>体验会员</span>
                      </p>
                      <ForwardFilled style={{ fontSize: 24, color: "red" }} />
                      <p>
                        <span>无广告</span>
                        <span>付费会员</span>
                      </p>
                    </div>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>信息自动刷新功能</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.promotion}>
                    <div className={styles.show}>
                      <p>
                        <span>无刷新</span>
                        <span>体验会员</span>
                      </p>
                      <ForwardFilled style={{ fontSize: 24, color: "red" }} />
                      <p>
                        <span>自动刷新</span>
                        <span>付费会员</span>
                      </p>
                    </div>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>相册容量</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.promotion}>
                    <div className={styles.show}>
                      <p>
                        <span>3000张</span>
                        <span>体验会员</span>
                      </p>
                      <ForwardFilled style={{ fontSize: 24, color: "red" }} />
                      <p>
                        <span>100000张</span>
                        <span>付费会员</span>
                      </p>
                    </div>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>相册分类</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.promotion}>
                    <div className={styles.show}>
                      <p>
                        <span>20个</span>
                        <span>体验会员</span>
                      </p>
                      <ForwardFilled style={{ fontSize: 24, color: "red" }} />
                      <p>
                        <span>50个</span>
                        <span>付费会员</span>
                      </p>
                    </div>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>产品条数</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.promotion}>
                    <div className={styles.show}>
                      <p>
                        <span>50条</span>
                        <span>体验会员</span>
                      </p>
                      <ForwardFilled style={{ fontSize: 24, color: "red" }} />
                      <p>
                        <span>10000条</span>
                        <span>付费会员</span>
                      </p>
                    </div>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>去广告</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>打造纯净商铺</p>
                    <p>降低买家流失</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>搜索右侧广告</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>数据跟踪</p>
                    <p>每展示100次可获得80次高频点击</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.optimize}>
              <div className={styles.title}>SEO小助手</div>
              <div className={styles.box}>
                <div className={styles.col}>
                  <h2>
                    <span>关键词挖掘工具</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>会员专享</p>
                    <p>一键挖掘关键词</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>专业团队攥写TDK</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>会员专享</p>
                    <p>提升搜索引擎对您的信息了解</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>文章伪原创小助手</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>会员专享</p>
                    <p>提升搜索引擎喜爱</p>
                    <p>获得更优排名</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.helper}>
              <div className={styles.title}>秒排宝小助手</div>
              <div className={styles.box}>
                <div className={styles.col}>
                  <h2>
                    <span>数据报表</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>SEO设置</p>
                    <p>产品收录监测</p>
                    <p>关键词排名监测</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <h2>
                    <span>代发服务</span>
                    <RightOutlined />
                  </h2>
                  <div className={styles.text}>
                    <p>解放双手，让你不再崩溃</p>
                    <p>关键词自由组合，确保无重复</p>
                    <div className={styles.status}>
                      <Tag color="red">未开通</Tag>
                      <Tag
                        color="#108ee9"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setMold(true);
                          setVisible(true);
                        }}
                      >
                        立即开通
                      </Tag>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
        </div>
      </div>
      <Modal
        title={mold ? "购买会员" : "新增店铺"}
        visible={visible}
        onCancel={() => setVisible(false)}
        centered
        maskClosable={false}
        width={530}
        footer={
          mold ? null : (
            <Space>
              <Button onClick={() => setVisible(false)}>取消</Button>
              <Button type="primary" onClick={() => form.submit()}>
                确定
              </Button>
            </Space>
          )
        }
      >
        {modalView(mold)}
      </Modal>
      <Drawer
        title="模板选择"
        placement="right"
        width={502}
        closable
        onClose={() => {
          setDrawer(false);
        }}
        visible={drawer}
      >
        <div className={styles.template}>
          {theme.map((value) => (
            <div className={styles.col}>
              <div className={styles.pic}>
                <img src={value.pic} />
              </div>
              <div className={styles.tip}>
                <Button
                  type="primary"
                  onClick={() => {
                    form.setFieldsValue({ theme: value.name });
                    setDrawer(false);
                  }}
                >
                  使用
                </Button>
              </div>
            </div>
          ))}
        </div>
      </Drawer>
    </div>
  );
}

export default Welcome;
